import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.516 4l-3.49 4.914L4.922 20H6v-1.842h5V20h2v-1.842h5V20h1.077l.897-11.13L16.486 4h-8.97zM8 22H3.078L1.974 8.35 6.484 2h11.03l4.512 6.301L20.923 22H16v-1.842h-1V22H9v-1.842H8V22zm1-11h2v3H9v-3zm4 0h2v3h-2v-3zm2-2H9V8l-2 2 1 5h8l1-5-2-2v1zm-4-3v1h2V6h3l3 3-1 8H6L5 9l3-3h3z"
    />
  </svg>
);
